import { render, staticRenderFns } from "./RequestView.vue?vue&type=template&id=44ffe6b5&"
import script from "./RequestView.vue?vue&type=script&lang=js&"
export * from "./RequestView.vue?vue&type=script&lang=js&"
import style0 from "./RequestView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports